import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useActiveSport } from "../sports/ActiveSportContext";
import { isArenaEntryLocation } from "../domain/sport/arenaEntryLocation";

/**
 * Ensures Sport Mode overlay is open when frequency strategy says so.
 * Renders the destination underneath (blurred by the overlay) — no route redirect.
 * Skips prompt during frictionless Arena join so entry is never blocked.
 */
export default function RequireActiveSport() {
  const { needsSelection, openSportSelection, selectionOpen } = useActiveSport();
  const location = useLocation();

  useEffect(() => {
    if (isArenaEntryLocation(location)) return;
    if (needsSelection && !selectionOpen) {
      openSportSelection("launch");
    }
  }, [
    needsSelection,
    selectionOpen,
    openSportSelection,
    location.pathname,
    location.search,
  ]);

  return <Outlet />;
}
